import apiSlice from './apiSlice';
import type {
  BetHistoryParams,
  BetHistoryResponse,
  BetHistoryRow,
  CasinoRoundHistoryPayload,
  CasinoRoundHistoryResponse,
  PendingBetsCountResponse,
  ProfitLossQueryParams,
  ProfitLossSummaryResponse,
} from '@/types/betReportTypes';

export const betApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBetHistory: builder.query<BetHistoryResponse<BetHistoryRow>, BetHistoryParams>({
      query: (params) => ({
        url: '/bet/history',
        method: 'GET',
        params,
      }),
      providesTags: ['BetHistory'],
    }),

    getPendingBetsCount: builder.query<PendingBetsCountResponse, void>({
      query: () => ({
        url: '/bet/pending-bets-count',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['CurrentBetCount'],
    }),

    getProfitLossSummary: builder.query<ProfitLossSummaryResponse, ProfitLossQueryParams>({
      query: (params) => ({
        url: '/bet/profit-loss/summary',
        method: 'GET',
        params,
      }),
    }),

    getCasinoRoundHistory: builder.query<CasinoRoundHistoryResponse, CasinoRoundHistoryPayload>({
      query: (params) => ({
        url: '/casino/round/history',
        method: 'GET',
        params: { ...params, t: Date.now() },
      }),
    }),
  }),
});

export const {
  useGetBetHistoryQuery,
  useGetPendingBetsCountQuery,
  useGetProfitLossSummaryQuery,
  useGetCasinoRoundHistoryQuery,
} = betApi;
